<!-- Detailinfo.vue -->
<template>
	<div v-if="detailInfo">
		<div v-if="detailInfo.bargain_info" class="bargain-wrapper">

			<div class="bargain-content" @click="bargainVisible=true">
				<div class="title">Bargain</div>
				<div class="content">
					<div>End before </div>
					<div><span v-if="day"><em>{{day}}</em>day</span><span><em>{{hours}}</em>hour</span><span><em>{{minute}}</em>minute</span><span><em>{{second}}</em>second</span></div>
				</div>
				<div class="arrow iconfont">&#xe650;</div>
			</div>
			<mt-popup v-model="bargainVisible" position="bottom" class="bargain-popup-wrapper">
				<div class="mt">Play details</div>
				<div class="mc">
					<div class="line">
            1. During the event, consumers can invite friends to help bargain, and after friends have cut the bottom price, they can buy goods at the bottom price;
					</div>
					<div class="line">
            2. After a friend helps to bargain, consumers must purchase the bargained goods within the validity period, and the overdue goods will be restored to the original price;
					</div>
					<div class="line">
            3. For the same product, the same user can only enjoy the preferential price once;
					</div>
					<div class="line">
            4. For the same product, the same user can only bargain for a friend once;
					</div>
					<div class="line">
            5. The number of bargained goods is limited, and you will not be able to buy them after they are sold out.
					</div>
				</div>
			</mt-popup>
		</div>
		<div class="ui-detail-info">

			<div class="info-header ui-flex">
				<h3>{{ detailInfo.goods_name }}</h3>
				<div class="favorite">
					<i class="iconfont" v-on:click="productUnlike()" v-if="isFavorate">&#xe6d5;</i>
					<i class="iconfont" v-on:click="productLike()" v-else>&#xe6d6;</i>
					<span>{{favoriteName}}</span>
				</div>
			</div>

			<div v-if="detailInfo.wholesale_info" class="price" style="display: flex">
				<div v-for="(item,index) in detailInfo.wholesale_info.wholesalegoods_price" :key="index" style="flex:1">
					<span class="current-price">${{item.price}}</span>
					<span class="num">{{item.num_text}}</span>
				</div>
			</div>
			<div v-else class="price">
			<span class="current-price">$<slot v-if="detailInfo.bargain_info">{{ detailInfo.bargain_info.bargain_floorprice }}</slot><slot v-else-if="detailInfo.pintuan_type==1">{{ detailInfo.pintuan_price }}</slot><slot v-else-if="detailInfo.promotion_type">{{ detailInfo.promotion_price }}</slot><slot v-else>{{ detailInfo.goods_price }}</slot>
			</span>
				<span class="old-price" v-if="detailInfo.goods_marketprice > 0">${{ detailInfo.goods_marketprice }}</span>
			</div>
			<div class="inviter_amount" v-if="detailInfo.inviter_money > 0">
				<span class="inviter_amount" >Distribution commission:${{ detailInfo.inviter_money }}</span>
			</div>

			<div class="info-sub ui-flex" v-if="detailInfo.goods_advword">
				<p>{{ detailInfo.goods_advword }}</p>
			</div>
			<div v-if="!detailInfo.bargain_info">
				<div class="info-promotions" v-if="detailInfo.pintuan_type=='pintuan'">
					<div class="left">
						<i>Group activities</i><br>
						<span v-if="detailInfo.pintuan_limit_quantity">You can purchase up to {{detailInfo.pintuan_limit_quantity}} pieces</span>
					</div>
					<span class="right">{{fromNow(detailInfo.pintuan_end_time)}} end</span>
				</div>
				<div class="info-promotions-qianggou" v-if="detailInfo.promotion_type=='groupbuy'">
					<div class="left">
						<i>Snap up</i>
<!--						<span v-if="detailInfo.upper_limit">You can purchase up to {{detailInfo.upper_limit}} pieces</span>-->
					</div>
          <div class="qianggou_time right" id="qianggou_time">
            <div>End countdown</div>
            <div>
              <span v-if="day"><em>{{day}}</em> days </span>
              <span><em>{{hours}}</em>:</span>
              <span><em>{{minute}}</em>:</span>
              <span><em>{{second}}</em></span>
            </div>
            <!--            {{fromNow(detailInfo.promotion_end_time)}}结束-->
          </div>
				</div>
				<div class="info-promotions" v-if="detailInfo.promotion_type=='xianshi'">
					<div class="left">
						<i>Limited time purchase</i>
						<span v-if="detailInfo.lower_limit">Minimum {{detailInfo.lower_limit}}</span>
					</div>
					<span class="right">{{fromNow(detailInfo.promotion_end_time)}} end</span>
				</div>
			</div>

			<div class="dss-sale">
				<dl>
					<dd class="mgdiscount-info">
						<span v-for="(item,index) in detailInfo.goods_mgdiscount_arr"><em>{{item.level_name}}</em> {{item.level_discount}} discount</span>&nbsp;&nbsp;
					</dd>
				</dl>
			</div>
		</div>
	</div>

</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { productLike, productUnlike } from '../../../../api/homegoodsdetail'
import { Toast, Indicator } from 'mint-ui'
export default {
  data () {
    return {
      bargainVisible: false,
      flag: false,
      day: 0,
      hours: 0,
      minute: 0,
      second: 0,
      time: false,
      orderTime: '', // 下单时间
      arrivalsTime: '', // 到达时间
      arrivalsTitle: '', // 到达时间的标题
      arrivalsRange: '' // 到达时间区间,
    }
  },
  computed: {
    ...mapState({
      isFavorate: state => state.goodsdetail.isFavorate,
      detailInfo: state => state.goodsdetail.detailInfo,
      currentProductId: state => state.goodsdetail.currentProductId,
      user: state => state.member.info
    }),
    favoriteName () {
      return this.isFavorate ? 'Followed' : 'Attention'
    }
  },
  created () {
  },
  mounted () {
    this.time = setInterval(() => {
      if (this.flag == true) {
        clearInterval(this.time)
      } else {
        this.timeDown()
      }
    }, 1000),
    this.time2 = setInterval(() => {
      if (this.flag2 == true) {
        clearInterval(this.time2)
      } else {
        this.timeDown2()
      }
    }, 1000)
  },
  methods: {
    ...mapMutations({
      saveInfo: 'saveDetailInfo',
      changeIndex: 'changeIndex',
      saveIsFavorate: 'saveIsFavorate'
    }),
    fromNow (time) {
      return this.$moment(time * 1000).fromNow()
    },
    /*
     * getCommentStatus： 去到评论页面
     */
    getCommentStatus () {
      this.changeIndex(2)
    },
    /*
     * productLike： 收藏商品
     */
    productLike () {
      if (this.user) {
        let id = this.detailInfo.goods_id
        productLike(id).then(res => {
          if (res) {
            this.saveIsFavorate(true)
          }
        }).catch(function (error) {
        Toast(error.message)
      })
      } else {
        this.$router.push({ name: 'HomeMemberLogin' })
      }
    },
    /*
     * productUnlike： 取消收藏
     */
    productUnlike () {
      if (this.user) {
        let id = this.detailInfo.goods_id
        productUnlike(id).then(res => {
          if (res) {
            this.saveIsFavorate(false)
          }
        })
      } else {
        this.$router.push({ name: 'HomeMemberLogin' })
      }
    },

    /*
	 * timeDown: 倒计时
	 */
    timeDown () {
      let end_time = false
      if (this.detailInfo.bargain_info) {
        end_time = this.detailInfo.bargain_info.bargain_endtime
      }
      if (end_time) {
        const endTime = new Date(end_time * 1000)
        const nowTime = new Date()
        let leftTime = parseInt((endTime.getTime() - nowTime.getTime()) / 1000)
        this.day = parseInt(leftTime / (24 * 60 * 60))
        this.hours = this.formate(parseInt((leftTime / (60 * 60)) % 24))
        this.minute = this.formate(parseInt((leftTime / 60) % 60))
        this.second = this.formate(parseInt(leftTime % 60))
        if (leftTime <= 0) {
          this.flag = true
          this.detailInfo.bargain_info = ''
          this.saveInfo(this.detailInfo)
        }
      }
    },
    /*
	 * timeDown: 倒计时2
	 */
    timeDown2 () {
      let end_time = false
      if (this.detailInfo.promotion_end_time) {
        end_time = this.detailInfo.promotion_end_time
      }
      if (end_time) {
        const endTime = new Date(end_time * 1000)
        const nowTime = new Date()
        let leftTime = parseInt((endTime.getTime() - nowTime.getTime()) / 1000)
        this.day = parseInt(leftTime / (24 * 60 * 60))
        this.hours = this.formate(parseInt((leftTime / (60 * 60)) % 24))
        this.minute = this.formate(parseInt((leftTime / 60) % 60))
        this.second = this.formate(parseInt(leftTime % 60))
        if (leftTime <= 0) {
          this.flag2 = true;
          document.getElementById("qianggou_time").innerHTML = 'The event is over';
        }
      }
    },
    /*
     * 格式化时间
     */
    formate (time) {
      if (time >= 10) {
        return time
      } else {
        return `0${time}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
	.bargain-wrapper{
		.bargain-content{
			padding:.5rem;color:#fff;
			background: #EA3F64;background-image: linear-gradient(to right, #ff5e00, #ea3f3f);
			display: flex;
			.title{flex:1;font-size:1rem;line-height: 1.2rem;}
			.content{width:auto;font-size:.6rem;line-height: .6rem;
				em{margin:0 .1rem}
			}
			.arrow{width:1rem;text-align: right;line-height: 1.2rem;}

		}
		.bargain-popup-wrapper{padding:.5rem;color:#333;box-sizing: border-box;padding-bottom: 3rem;
			.mt{font-size:.8rem;text-align: center}
			.mc{font-size:.6rem;
				.line{margin-top:.5rem;}
			}
		}
	}
.ui-detail-info {
	padding: 0 0.75rem;
	background: #ffffff;
	.ui-flex {
		display: flex;
		/*justify-content: space-between;*/
		align-content: center;
		align-items: center;
		flex-basis: 100%;
		width: auto;
	}
	.info-header {
		padding: 0.4rem 0;
		h3 {
			color: #333;
			font-size: 0.7rem;
			padding: 0;
			margin: 0;
			font-weight: normal;
			line-height:1.2rem;
			height:2.4rem;
			width:85%;
			overflow:hidden;
		}
		.favorite {
			height:2.4rem;
			text-align:center;
			i{width:2.4rem;display:block;font-size:1.2rem;line-height:1.2rem;color:#e93b3d;}
			span{font-size:0.5rem;line-height:1rem;height:1rem;display:block;}
		}
	}

	.price {
		padding-bottom: 0.4rem;
		display: flex;
		span {
			display: block;
			font-weight: normal;
			&.current-price {
				font-size: 0.7rem;
				color: $primaryColor;
				line-height: 1rem;
			}
			&.num{
				font-size: 0.6rem;
				color:#666;
			}
			&.old-price {
				font-size: 0.6rem;
				color: rgba(164, 170, 179, 1);
				line-height: 1rem;
				text-decoration: line-through;
				margin-left: 0.3rem;
			}
		}
	}
	.inviter_amount {
		padding-bottom: 0.4rem;
		display: flex;
		span {
			font-size: .7rem;
			color: #4e545d;
		}
	}

	.info-sub {
		border-bottom: 0.5px solid #e8eaed;
		padding-bottom: 0.25rem;
		p {
			padding: 0;
			margin: 0;
			color: $primaryColor;
			font-size: 0.5rem;
		}
	}

	.info-promotions {
		display: flex;
		justify-content: flex-start;
		align-content: center;
		align-items: center;
		padding: 0.75rem 0;
		border-bottom: 0.5px solid #e8eaed;
		line-height:1.5rem;
		span {
			margin-left: 0.15rem;
			font-size: 0.6rem;
			color: rgba(143, 142, 148, 1);
		}
		img {
			width: 30.4rem;
		}
	}
	.info-promotions i{font-size:.7rem;border:1px solid $primaryColor;color:$primaryColor;padding:0.1rem 0.3rem;border-radius:0.1rem;}
	.info-promotions .left{flex:1}
	.info-promotions .right{
    width:5rem;
    text-align: right;
  }

	.dss-sale .mgdiscount-info{font-size:.7rem;color:#666;padding: .2rem 0}
	.dss-sale .mgdiscount-info span{
    display: inline-block;
    margin-right:3px;
    word-break: break-all;
    margin-bottom: 6px;
  }
	.dss-sale .mgdiscount-info em{background:#f23030;color:#fff;padding: .1rem}
}

  .qianggou_time{
    width: auto;
    font-size: .6rem;
    line-height: .6rem;
    color: #f71471;
  }
  .info-promotions-qianggou {
    display: flex;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
    height: 2.6rem;
    padding: 0.55rem 0;
    margin-top: 0.3rem;
    border-bottom: 0.5px solid #e8eaed;
    line-height:1.7rem;
    background: url("../../../../assets/image/home/goods_qianggou.jpg");
    background-repeat: no-repeat;
    background-position: left top;
    background-size: cover;
    border-radius: 0.4rem;
    overflow: hidden;
    span {
      font-size: 0.6rem;
      color: #f71471;
    }
    em{
      display: inline-block;
      width: 0.9rem;
      height: 1rem;
      line-height: 1rem;
      background-color: #f71471;
      color: #fff;
      text-align: center;
      border-radius: 4px;
    }
    img {
      width: 30.4rem;
    }
  }
  .info-promotions-qianggou .qianggou_time{
    line-height:1rem;
    text-align: center;
  }
  .info-promotions-qianggou .left{
    flex:1;
    height: 1.7rem;
    position: relative;
  }
  .info-promotions-qianggou .left i{
    position: absolute;
    left: 0.72rem;
    top: -0.1rem;
    font-size:.5rem;
    padding: 0.15rem 0.2rem;
    background-color: #CD156C;
    color:#fff;
    border-radius:0.3rem;
    /*margin-left: 1rem;*/
  }

  .info-promotions-qianggou .right{
    /*width:6.8rem;*/
    margin-right: 0.4rem;
  }

</style>